import React from "react";

const KycOnfido = () => (
  <svg
    width="182"
    height="123"
    viewBox="0 0 182 123"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d)">
      <rect x="4" y="21" width="154" height="96" rx="12" fill="#E9EFF5" />
      <rect
        x="5.5"
        y="22.5"
        width="151"
        height="93"
        rx="10.5"
        stroke="#B7CCE1"
        strokeWidth="3"
      />
    </g>
    <rect
      opacity="0.8"
      x="119.976"
      y="70.5557"
      width="27.8848"
      height="6"
      rx="2"
      fill="#B7CCE1"
    />
    <rect
      opacity="0.8"
      x="71.1768"
      y="59.7778"
      width="76.6831"
      height="6"
      rx="2"
      fill="#B7CCE1"
    />
    <rect
      opacity="0.8"
      x="90.8232"
      y="49"
      width="57.037"
      height="6"
      rx="2"
      fill="#B7CCE1"
    />
    <path
      d="M47.6929 54.4563C47.6929 59.8095 43.3533 64.1492 38 64.1492C32.6468 64.1492 28.3071 59.8095 28.3071 54.4563C28.3071 49.103 32.6468 44.7634 38 44.7634C43.3533 44.7634 47.6929 49.103 47.6929 54.4563Z"
      fill="white"
      fillOpacity="0.1"
    />
    <path
      d="M55.8242 77.1592C55.1345 74.6304 52.8376 72.876 50.2165 72.876H25.7811C23.1599 72.876 20.863 74.6304 20.1734 77.1592L17.124 88.3404C16.4517 90.8054 18.3074 93.2349 20.8624 93.2349H55.1351C57.6902 93.2349 59.5459 90.8054 58.8736 88.3404L55.8242 77.1592Z"
      fill="white"
      fillOpacity="0.1"
    />
    <path
      d="M47.6929 54.4563C47.6929 59.8095 43.3533 64.1492 38 64.1492C32.6468 64.1492 28.3071 59.8095 28.3071 54.4563C28.3071 49.103 32.6468 44.7634 38 44.7634C43.3533 44.7634 47.6929 49.103 47.6929 54.4563Z"
      stroke="#92B0CE"
      strokeWidth="5"
      strokeLinejoin="round"
    />
    <path
      d="M55.8242 77.1592C55.1345 74.6304 52.8376 72.876 50.2165 72.876H25.7811C23.1599 72.876 20.863 74.6304 20.1734 77.1592L17.124 88.3404C16.4517 90.8054 18.3074 93.2349 20.8624 93.2349H55.1351C57.6902 93.2349 59.5459 90.8054 58.8736 88.3404L55.8242 77.1592Z"
      stroke="#92B0CE"
      strokeWidth="5"
      strokeLinejoin="round"
    />
    <g filter="url(#filter1_d)">
      <path
        d="M176.095 32.0108C176.095 47.5272 163.516 60.1058 148 60.1058C132.484 60.1058 119.905 47.5272 119.905 32.0108C119.905 16.4944 132.484 3.91583 148 3.91583C163.516 3.91583 176.095 16.4944 176.095 32.0108Z"
        fill="#FFE099"
      />
      <path
        d="M148 35.875V16.5M148 47.5V41.6875M176.095 32.0108C176.095 47.5272 163.516 60.1058 148 60.1058C132.484 60.1058 119.905 47.5272 119.905 32.0108C119.905 16.4944 132.484 3.91583 148 3.91583C163.516 3.91583 176.095 16.4944 176.095 32.0108Z"
        stroke="#CA9008"
        strokeWidth="3"
      />
    </g>
    <defs>
      <filter
        id="filter0_d"
        x="0"
        y="19"
        width="162"
        height="104"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0666667 0 0 0 0 0.168627 0 0 0 0 0.266667 0 0 0 0.18 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d"
        x="113"
        y="-1"
        width="70"
        height="70"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0666667 0 0 0 0 0.168627 0 0 0 0 0.266667 0 0 0 0.18 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default KycOnfido;
